import cs from "./cs.json";
import en from "./en.json";
export default {
  en: {
    translation: en
  },
  cs: {
    translation: cs
  }
};
